// Trimming on every keystroke causes unexpected behavior
// Since trim() removes spaces immediately, users won’t be able to type spaces at the beginning or end.
// Here trim only accidental first type of space
export const validateSearchQuery = (query: string | undefined): string | undefined => {
  const trimmedQuery = query?.trim()
  if (trimmedQuery) {
    return query
  }
  return undefined
}
